import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSelectedCompany } from "~/shared/store/company/hooks/useSelectedCompany";

/**
 * Sends the dispatcher to the dashboard with one object already selected: the
 * map zooms to it and the info panel opens, which is what a plate number in a
 * registry is asked to do. Mirrors the query the panel reads (`useInfoPanel`).
 */
export function useShowOnDashboard() {
  const navigate = useNavigate();
  const { selectedCompanyId } = useSelectedCompany();

  const showTruck = useCallback(
    (truckId: bigint | number | string) => {
      if (!selectedCompanyId) return;
      navigate(`/${selectedCompanyId}/dashboard?infoType=truck&infoId=${String(truckId)}`);
    },
    [navigate, selectedCompanyId],
  );

  return { showTruck };
}
